import { configureStore } from '@reduxjs/toolkit'
import reducers from './reducers'
import { isDevEnv } from '../settings/environment'

/**
 * Factory to create a new store instance as a singleton.
 */
const factoryStore = (initialState = {}) => {
  const store = configureStore({
    reducer: reducers, // Your combined reducers
    middleware: getDefaultMiddleware => getDefaultMiddleware(),
    preloadedState: initialState,
    devTools: isDevEnv // Enable Redux DevTools only in development
  })

  return store
}

/**
 * Gets the current store instance.
 */
const storeSingleton = factoryStore()

export default storeSingleton
